module.exports = __webpack_public_path__ + "static/img/5.28db0ed3.jpg";